// file: inc/blocks/tabs-container/view.js
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wp-block-edufit-tabs-container').forEach((container, index) => {
    const buttons = Array.from(container.querySelectorAll('[data-tab-button]'));
    const contents = Array.from(container.querySelectorAll('[data-tab-content]'));

    if (buttons.length !== contents.length || buttons.length === 0) return;

    const isVertical = container.classList.contains('vertical');
    const tabIdPrefix = `tab-${index}`;

    const ul = document.createElement('ul');
    ul.className = `nav nav-tabs${isVertical ? ' flex-column' : ''}`;
    ul.id = `${tabIdPrefix}-tabs`;
    ul.setAttribute('role', 'tablist');

    const contentWrapper = document.createElement('div');
    contentWrapper.className = 'tab-content';
    contentWrapper.id = `${tabIdPrefix}-content`;

    buttons.forEach((btnWrapper, i) => {
      const contentWrapperEl = contents[i];

      const tabId = `${tabIdPrefix}-tab-${i}`;
      const panelId = `${tabIdPrefix}-panel-${i}`;

      const li = document.createElement('li');
      li.className = 'nav-item';
      li.setAttribute('role', 'presentation');

      const btn = btnWrapper.querySelector('button');
      if (!btn) return;

      btn.classList.add('nav-link');
      if (i === 0) btn.classList.add('active');

      btn.id = tabId;
      btn.setAttribute('data-bs-toggle', 'tab');
      btn.setAttribute('data-bs-target', `#${panelId}`);
      btn.setAttribute('type', 'button');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-controls', panelId);
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');

      li.appendChild(btn);
      ul.appendChild(li);

      const content = contentWrapperEl.cloneNode(true);
      content.classList.add('tab-pane', 'fade');
      if (i === 0) content.classList.add('show', 'active');
      content.id = panelId;
      content.setAttribute('role', 'tabpanel');
      content.setAttribute('aria-labelledby', tabId);

      contentWrapper.appendChild(content);
    });

    container.innerHTML = '';
    container.appendChild(ul);
    container.appendChild(contentWrapper);
  });
});
